import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Default Checks"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "form-check mb-3" }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  id: "flexCheckDefault"
                }),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexCheckDefault"
                }, " Default checkbox ")
              ]),
              _createElementVNode("div", { class: "form-check" }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  id: "flexCheckChecked",
                  checked: ""
                }),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexCheckChecked"
                }, " Checked checkbox ")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<div class=\"form-check mb-3\">\n<input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"flexCheckDefault\">\n<label class=\"form-check-label\" for=\"flexCheckDefault\">\nDefault checkbox\n</label>\n</div>\n<div class=\"form-check\">\n<input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"flexCheckChecked\" checked>\n<label class=\"form-check-label\" for=\"flexCheckChecked\">\nChecked checkbox\n</label>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Disabled Check"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "form-check mb-3" }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  id: "flexCheckIndeterminateDisabled",
                  disabled: ""
                }),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexCheckIndeterminateDisabled"
                }, " Disabled indeterminate checkbox ")
              ]),
              _createElementVNode("div", { class: "form-check mb-3" }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  id: "flexCheckDisabled",
                  disabled: ""
                }),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexCheckDisabled"
                }, " Disabled checkbox ")
              ]),
              _createElementVNode("div", { class: "form-check" }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  value: "",
                  id: "flexCheckCheckedDisabled",
                  checked: "",
                  disabled: ""
                }),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexCheckCheckedDisabled"
                }, " Disabled checked checkbox ")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<div class=\"form-check mb-3\">\n<input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"flexCheckIndeterminateDisabled\" disabled>\n<label class=\"form-check-label\" for=\"flexCheckIndeterminateDisabled\">\nDisabled indeterminate checkbox\n</label>\n</div>\n<div class=\"form-check mb-3\">\n<input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"flexCheckDisabled\" disabled>\n<label class=\"form-check-label\" for=\"flexCheckDisabled\">\nDisabled checkbox\n</label>\n</div>\n<div class=\"form-check\">\n<input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"flexCheckCheckedDisabled\" checked disabled>\n<label class=\"form-check-label\" for=\"flexCheckCheckedDisabled\">\nDisabled checked checkbox\n</label>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Default Radios"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "form-check mb-3" }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "flexRadioDefault",
                  id: "flexRadioDefault1"
                }),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexRadioDefault1"
                }, " Default radio ")
              ]),
              _createElementVNode("div", { class: "form-check" }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "flexRadioDefault",
                  id: "flexRadioDefault2",
                  checked: ""
                }),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexRadioDefault2"
                }, " Default checked radio ")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<div class=\"form-check mb-3\">\n<input class=\"form-check-input\" type=\"radio\" name=\"flexRadioDefault\" id=\"flexRadioDefault1\">\n<label class=\"form-check-label\" for=\"flexRadioDefault1\">\nDefault radio\n</label>\n</div>\n<div class=\"form-check\">\n<input class=\"form-check-input\" type=\"radio\" name=\"flexRadioDefault\" id=\"flexRadioDefault2\" checked>\n<label class=\"form-check-label\" for=\"flexRadioDefault2\">\nDefault checked radio\n</label>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Disabled Radios"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent4"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "form-check mb-3" }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "flexRadioDisabled",
                  id: "flexRadioDisabled",
                  disabled: ""
                }),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexRadioDisabled"
                }, " Disabled radio ")
              ]),
              _createElementVNode("div", { class: "form-check" }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "flexRadioDisabled",
                  id: "flexRadioCheckedDisabled",
                  checked: "",
                  disabled: ""
                }),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: "flexRadioCheckedDisabled"
                }, " Disabled checked radio ")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, "\n<div class=\"form-check\">\n<input class=\"form-check-input\" type=\"radio\" name=\"flexRadioDisabled\" id=\"flexRadioDisabled\" disabled>\n<label class=\"form-check-label\" for=\"flexRadioDisabled\">\nDisabled radio\n</label>\n</div>\n<div class=\"form-check\">\n<input class=\"form-check-input\" type=\"radio\" name=\"flexRadioDisabled\" id=\"flexRadioCheckedDisabled\" checked disabled>\n<label class=\"form-check-label\" for=\"flexRadioCheckedDisabled\">\nDisabled checked radio\n</label>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Switches Buttons"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab5",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview5-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code5-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent5"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "btn-check",
                id: "btn-check",
                autocomplete: "off"
              }),
              _createElementVNode("label", {
                class: "btn btn-primary me-1",
                for: "btn-check"
              }, "Single toggle"),
              _createElementVNode("input", {
                type: "checkbox",
                class: "btn-check",
                id: "btn-check-2",
                checked: "",
                autocomplete: "off"
              }),
              _createElementVNode("label", {
                class: "btn btn-primary me-1",
                for: "btn-check-2"
              }, "Checked"),
              _createElementVNode("input", {
                type: "checkbox",
                class: "btn-check",
                id: "btn-check-3",
                autocomplete: "off",
                disabled: ""
              }),
              _createElementVNode("label", {
                class: "btn btn-primary me-1",
                for: "btn-check-3"
              }, "Disabled")
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode5"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode5"
                }, "\n<input type=\"checkbox\" class=\"btn-check\" id=\"btn-check\" autocomplete=\"off\">\n<label class=\"btn btn-primary\" for=\"btn-check\">Single toggle</label>\n\n<input type=\"checkbox\" class=\"btn-check\" id=\"btn-check-2\" checked autocomplete=\"off\">\n<label class=\"btn btn-primary\" for=\"btn-check-2\">Checked</label>\n\n<input type=\"checkbox\" class=\"btn-check\" id=\"btn-check-3\" autocomplete=\"off\" disabled>\n<label class=\"btn btn-primary\" for=\"btn-check-3\">Disabled</label>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Outline Rounded Buttons"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab6",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview6-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code6-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent6"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                name: "options",
                id: "option1",
                autocomplete: "off",
                checked: ""
              }),
              _createElementVNode("label", {
                class: "btn btn-secondary me-1",
                for: "option1"
              }, "Checked"),
              _createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                name: "options",
                id: "option2",
                autocomplete: "off"
              }),
              _createElementVNode("label", {
                class: "btn btn-secondary me-1",
                for: "option2"
              }, "Radio"),
              _createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                name: "options",
                id: "option3",
                autocomplete: "off",
                disabled: ""
              }),
              _createElementVNode("label", {
                class: "btn btn-secondary me-1",
                for: "option3"
              }, "Disabled"),
              _createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                name: "options",
                id: "option4",
                autocomplete: "off"
              }),
              _createElementVNode("label", {
                class: "btn btn-secondary",
                for: "option4"
              }, "Radio")
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode6"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode6"
                }, "\n<input type=\"radio\" class=\"btn-check\" name=\"options\" id=\"option1\" autocomplete=\"off\" checked>\n<label class=\"btn btn-secondary\" for=\"option1\">Checked</label>\n\n<input type=\"radio\" class=\"btn-check\" name=\"options\" id=\"option2\" autocomplete=\"off\">\n<label class=\"btn btn-secondary\" for=\"option2\">Radio</label>\n\n<input type=\"radio\" class=\"btn-check\" name=\"options\" id=\"option3\" autocomplete=\"off\" disabled>\n<label class=\"btn btn-secondary\" for=\"option3\">Disabled</label>\n\n<input type=\"radio\" class=\"btn-check\" name=\"options\" id=\"option4\" autocomplete=\"off\">\n<label class=\"btn btn-secondary\" for=\"option4\">Radio</label>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Block Buttons"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab7",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview7-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview7-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview7-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code7-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code7-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code7-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent7"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview7-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview7-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex flex-wrap gap-2" }, [
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "btn-check",
                    id: "btn-check-outlined",
                    autocomplete: "off"
                  }),
                  _createElementVNode("label", {
                    class: "btn btn-outline-primary",
                    for: "btn-check-outlined"
                  }, "Single toggle")
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "btn-check",
                    id: "btn-check-2-outlined",
                    checked: "",
                    autocomplete: "off"
                  }),
                  _createElementVNode("label", {
                    class: "btn btn-outline-secondary",
                    for: "btn-check-2-outlined"
                  }, "Checked")
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "options-outlined",
                    id: "success-outlined",
                    autocomplete: "off",
                    checked: ""
                  }),
                  _createElementVNode("label", {
                    class: "btn btn-outline-success",
                    for: "success-outlined"
                  }, "Checked success radio")
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "options-outlined",
                    id: "danger-outlined",
                    autocomplete: "off"
                  }),
                  _createElementVNode("label", {
                    class: "btn btn-outline-danger",
                    for: "danger-outlined"
                  }, "Danger radio")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code7-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code7-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode7"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode7"
                }, "\n<input type=\"checkbox\" class=\"btn-check\" id=\"btn-check-outlined\" autocomplete=\"off\">\n<label class=\"btn btn-outline-primary\" for=\"btn-check-outlined\">Single toggle</label><br>\n\n<input type=\"checkbox\" class=\"btn-check\" id=\"btn-check-2-outlined\" checked autocomplete=\"off\">\n<label class=\"btn btn-outline-secondary\" for=\"btn-check-2-outlined\">Checked</label><br>\n\n<input type=\"radio\" class=\"btn-check\" name=\"options-outlined\" id=\"success-outlined\" autocomplete=\"off\" checked>\n<label class=\"btn btn-outline-success\" for=\"success-outlined\">Checked success radio</label>\n\n<input type=\"radio\" class=\"btn-check\" name=\"options-outlined\" id=\"danger-outlined\" autocomplete=\"off\">\n<label class=\"btn btn-outline-danger\" for=\"danger-outlined\">Danger radio</label>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}